import { render, staticRenderFns } from "./ServiceComponentsLayout.vue?vue&type=template&id=2f7ab6e0"
import script from "./ServiceComponentsLayout.vue?vue&type=script&lang=js"
export * from "./ServiceComponentsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports